import React from "react";
import { Route, Switch } from "react-router-dom";
import { Helmet } from "react-helmet";

import MessagePanel from "components/library/MessagePanel";
import NavigationHeader from "dashboard/containers/NavigationHeader";
import Users from "settings/containers/Users";
import User from "settings/components/User";
import SpecialFeatures from "settings/containers/SpecialFeatures";
import TrendingTopics from "settings/containers/TrendingTopics";
import Tags from "settings/containers/Tags";
import CreateTag from "settings/components/CreateTag";
import DeleteTag from "settings/components/DeleteTag";
import MergeTags from "settings/containers/MergeTags";
import WithPermissions from "components/library/WithPermissions";
import TakeoverPanel from "components/library/TakeoverPanel";
import NewUser from "settings/components/NewUser";

import styles from "./Settings.css";

export default function Settings() {
  return (
    <div>
      <Helmet>
        <title>Settings</title>
      </Helmet>

      <NavigationHeader />
      <MessagePanel />

      <main className={styles.main}>
        <Switch>
          <Route exact path="/settings/trending" component={TrendingTopics} />
          <Route
            exact
            path="/settings/features"
            render={props => (
              <WithPermissions
                required={["config.feature.special_features_list"]}
              >
                <SpecialFeatures {...props} />
              </WithPermissions>
            )}
          />
          <Route exact path="/settings/tags" component={Tags} />
          <Route
            exact
            path="/settings/tags/add"
            render={props => (
              <WithPermissions required={["content.add_tag"]}>
                <CreateTag {...props} />
              </WithPermissions>
            )}
          />
          <Route
            exact
            path="/settings/tags/delete"
            render={props => (
              <WithPermissions required={["content.delete_tag"]}>
                <DeleteTag {...props} />
              </WithPermissions>
            )}
          />
          <Route
            exact
            path="/settings/tags/merge"
            render={props => (
              //per the backend, add_tag is the correct permission for merging
              <WithPermissions required={["content.add_tag"]}>
                <MergeTags {...props} />
              </WithPermissions>
            )}
          />
          <Route path="/settings/user/me" component={User} />
          <Route
            path="/settings/user/:username"
            render={props => (
              <WithPermissions required={["users.change_user"]}>
                <TakeoverPanel>
                  <User {...props} />
                </TakeoverPanel>
              </WithPermissions>
            )}
          />
          <Route exact path="/settings/users" component={Users} />
          <Route
            exact
            path="/settings/users/new"
            render={props => (
              <WithPermissions
                required={["config.feature.user_invite", "users.add_user"]}
              >
                <TakeoverPanel>
                  <NewUser {...props} />
                </TakeoverPanel>
              </WithPermissions>
            )}
          />
          <Route exact path="/settings/sections" render={() => null} />
        </Switch>
      </main>
    </div>
  );
}
